export const ACTIVE = 'active';

export const TRIALING = 'trialing';

export const INCOMPLETE = 'incomplete';

export const INCOMPLETE_EXPIRED = 'incomplete_expired';

export const PATS_DUE = 'past_due';

export const CANCELED = 'canceled';

export const UNPAID = 'unpaid';
